import axios from 'axios'
import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'

export default function dataToFormData(data) {
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key])
    }
  })
  return formData
}

export const graphqlFetch = (data) =>
  axios({
    baseURL: '',
    url: '/graphql',
    method: 'post',
    headers: {
      accept: 'application/json',
    },
    data,
  })

// Native equivalent of the previous `flow(getFp('edges'), mapFp('node'))`
// pipeline. The `lodash/fp/*` imports each pulled the chain-wrapper /
// curry / placeholder machinery (`_createWrap`, `_LazyWrapper`, etc.,
// ~94 KB combined) onto every chunk that reached this file.
//
// JSDoc keeps the return type wide (`any[]`) so existing callers that
// pass through arrays or untyped connections don't pick up new TS
// implicit-any errors — same shape as lodash/fp's `mapFp` return.
/**
 * @param {any} connection
 * @returns {any[]}
 */
export const getConnectionNodes = (connection) =>
  (connection?.edges ?? []).map((edge) => edge?.node)

export const fetchMoreFromCollection = (
  data,
  fetchMore,
  path = '',
  cursorVariable = 'cursor',
) => {
  const {
    pageInfo: { endCursor },
  } = get(data, path)
  fetchMore({
    variables: {
      [cursorVariable]: endCursor,
    },
    updateQuery: (previousResult, { fetchMoreResult }) => {
      const { edges: previousEdges } = get(previousResult, path, {})
      const { edges: nextEdges, pageInfo: nextPageInfo } = get(
        fetchMoreResult,
        path,
        {},
      )
      const nextResult = cloneDeep(previousResult)
      set(nextResult, `${path}.pageInfo`, nextPageInfo)
      set(nextResult, `${path}.edges`, [...previousEdges, ...nextEdges])

      return nextEdges.length ? nextResult : previousResult
    },
  })
}
